import { useTranslation } from '@axo/shared/i18n';
import { Toast } from '@axo/ui-core/components/Toast';
import { ErrorToastProps } from '../ErrorToast';

export const Unknown = ({ error, onClose }: ErrorToastProps) => {
  const { t } = useTranslation();

  return (
    <Toast
      isOpen={!!error}
      onClose={onClose}
      feedbackState="error"
      title={t('ErrorToast.Unknown.title')}
      description={t('ErrorToast.Unknown.description')}
      duration={5000}
    />
  );
};
